import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["button"];
  static values = {
    formUrl: String,
    targetForm: String,
  };

  handleSubmit(event) {
    event.preventDefault();
    const buttonFormData = new FormData(this.element.form);
    const targetFormData = new FormData(document.getElementById(this.targetFormValue));

    buttonFormData.set("_method", "post"); // Change to post
    targetFormData.set("_method", "post"); // Change to post

    for (const [key, value] of targetFormData.entries()) {
      buttonFormData.set(key, value);
    }

    post(this.formUrlValue, {
      body: buttonFormData,
      responseKind: "turbo-stream",
    });
  }

  toggleDisabled(event) {
    const formSendable = event.detail.email || (event.detail.phone && event.detail.phoneSmsEnabled);
    this.element.disabled = !formSendable;
  }
}
